export default "__VITE_ASSET__BJjgDX_U__"